<template>
    <b-container class="highlight-container">
        <!-- <router-link to="/"><i class="fas fa-times btn--close"></i></router-link> -->
        <router-link :to="`/${form.sourceQuery}`"><i class="fas fa-times btn--close"></i></router-link>
        <b-img src="/img/icons/community-title.svg" class="community-logo" />
            <b-row>
                <b-col md="12" class="text-center px-0">
                    <h2 class="text--extrabold mb-10 flexFont">Built From The Ground Up</h2>
                    <p v-scroll-reveal>
                        At New Seaton, we have that new home feeling throughout 
                        <br class="d-none d-md-block">
                        our whole community. Every detail of this community has been planned 
                        <br class="d-none d-sm-block">
                        to make your life easier.
                    </p>
                    <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
                        <b-img src="/img/white-spacer.png" fluid center alt="New Seaton Parks"/>
                    </div>
                </b-col>
            </b-row>

            <div class='home-container'>
                <b-row class="site-logo" v-scroll-reveal="{delay: 150}">
                    <b-col md="8" sm="6" class="mb-2">
                        <b-img src="/img/aspenridge-logo.png" fluid />  
                    </b-col>
                        <b-col md="4" sm="6" class="text-center">
                            <br />
                            <h4>View other builders</h4>
                            <button class='black-button'>
                                <nuxt-link to="/brookfieldHomes">
                                <!-- <nuxt-link :to="`/brookfieldHomes${form.sourceQuery}`"> -->
                                    <b-img class="black-button-img" src="/img/icons/button-logo-brookfield.png" fluid alt="Brookfield"/>
                                </nuxt-link>
                            </button>

                            <button class='black-button'>
                                <nuxt-link to="/towerhillHomes">
                                <!-- <nuxt-link :to="`/towerhillHomes${form.sourceQuery}`"> -->
                                    <b-img class="black-button-img" src="/img/icons/button-logo-towerhill.png" fluid alt="Towerhill"/>
                                </nuxt-link>
                            </button>
                    </b-col>
                </b-row>

            <!-- First House Section -->
            <b-row class="background--white pb-30">
                <b-col md="10" offset-md="1" class="text-center">
                    <b-row>
                        <h2 class="home-container-title purple">
                            30' Detached
                        </h2>
                        <b-col v-for="home in aspenridge30" :key="home.homeTitle" xl="4" md="6" lg="6" sm="6" class="px-2 my-2 home-photo" >
                            <a target="_blank" :href="home.homeSitePlanPDF">
                                    <b-img :src="home.homePhoto" fluid/>
                                <div class="home-info purple">
                                    <div>
                                        <h1>{{ home.homeTitle }}</h1>
                                        <p>
                                        <span v-for="elevation in home.homeElevation" :key="elevation">
                                            {{ elevation }}
                                        </span>
                                        </p>
                                    </div>
                                    <div>
                                        <b-img src="/img/icons/area.png" width="30" />
                                    </div>
                                </div>
                            </a>
                        </b-col>                                
                    </b-row>
                </b-col>
            </b-row>

            <!-- Second House Section -->
            <b-row class="background--white pb-30">
                <b-col md="10" offset-md="1" class="text-center">
                    <b-row>
                        <h2 class="home-container-title yellow">
                            36' Detached
                        </h2>
                        <b-col v-for="home in aspenridge36" :key="home.homeTitle" xl="4" md="6" lg="6" sm="6" class="my-2 home-photo" >
                            <a target="_blank" :href="home.homeSitePlanPDF">
                                <b-img :src="home.homePhoto" fluid/>
                                <div class='home-info yellow'>
                                    <div>
                                        <h1>{{ home.homeTitle }}</h1>
                                        <p>
                                        <span v-for="elevation in home.homeElevation" :key="elevation">
                                            {{ elevation }}
                                        </span>
                                        </p>
                                    </div>
                                    <div>
                                        <b-img src="/img/icons/area.png" width="30" />
                                    </div>
                                </div>
                            </a>
                        </b-col>                                
                    </b-row>
                </b-col>
            </b-row>

            <!-- Third House Section -->
            <b-row class="background--white pb-30">
                <b-col md="10" offset-md="1" class="text-center">
                    <b-row>
                        <h2 class="home-container-title orange">
                            43' Detached
                        </h2>
                        <b-col v-for="home in aspenridge43" :key="home.homeTitle" xl="4" md="6" lg="6" sm="6" class="my-2 px-2 home-photo" >
                            <a target="_blank" :href="home.homeSitePlanPDF">
                                    <img :src="home.homePhoto" fluid alt="home photo"/>
                                <div class='home-info orange'>
                                    <div>
                                        <h1>{{ home.homeTitle }}</h1>
                                        <p>
                                        <span v-for="elevation in home.homeElevation" :key="elevation">
                                            {{ elevation }}
                                        </span>
                                        </p>
                                    </div>
                                    <div>
                                        <b-img src="/img/icons/area.png" width="30" />
                                    </div>
                                </div>
                            </a>
                        </b-col>                                
                    </b-row>
                </b-col>
            </b-row>

            <!-- Fourth House Section -->
            <b-row class="background--white pb-30">
                <b-col md="10" offset-md="1" class="text-center">
                    <b-row>
                        <h2 class="home-container-title blue">
                            45' Detached
                        </h2>
                        <b-col v-for="home in aspenridge45" :key="home.homeTitle" xl="4" md="6" lg="6"  class="my-2 px-2 home-photo" >
                            <a target="_blank" :href="home.homeSitePlanPDF">
                                <img :src="home.homePhoto" fluid alt="home photo"/>
                                <div class='home-info blue'>
                                    <div>
                                        <h1>{{ home.homeTitle }}</h1>
                                        <p>
                                        <span v-for="elevation in home.homeElevation" :key="elevation">
                                            {{ elevation }}
                                        </span>
                                        </p>
                                    </div>
                                    <div>
                                        <b-img src="/img/icons/area.png" width="30" />
                                    </div>
                                </div>
                            </a>
                        </b-col>                                
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>



<script>
  export default {
    data() {
        return {
            aspenridge30: [
                {
                "homeTitle": "Gord",
                "homeElevation": [
                    "style a 2215 sq ft. | ",
                    "style b 2221 sq ft. | ",
                    "style c 2212 sq ft.",
                ],
                "homePhoto": "/img/houses/gord.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Gord.pdf"
            },
            {
                "homeTitle": "Lennon",
                "homeElevation": [
                    "style a 2272 sq ft.",
                ],
                "homePhoto": "/img/houses/lennon.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Lennon.pdf"
            },
            {
                "homeTitle": "Morrison",
                "homeElevation": [
                    "style a 2040 sq ft. | ",
                    "style b 2036 sq ft. | ",
                    "style c 2060 sq ft.",
                ],
                "homePhoto": "/img/houses/morrison.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Morrison.pdf"
            }],
            aspenridge36: [
                {
                "homeTitle": "Cash",
                "homeElevation": [
                    "style a 2402 sq ft. | ",
                    "style b 2396 sq ft. | ",
                    "style c 2402 sq ft.",
                ],
                "homePhoto": "/img/houses/cash.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Cash.pdf"
            },
            {
                "homeTitle": "Clapton",
                "homeElevation": [
                    "style a 2605/2596 sq ft. | ",
                    "style b 2596/2587 sq ft. | ",
                    "style c 2599/2590 sq ft.",
                ],
                "homePhoto": "/img/houses/clapton.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Clapton.pdf"
            },
            {
                "homeTitle": "Cobain",
                "homeElevation": [
                    "style a 2611 sq ft. | ",
                    "style b 2585 sq ft. | ",
                    "style c 2611 sq ft.",
                ],
                "homePhoto": "/img/houses/cobain.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Cobain.pdf"
            }],
            aspenridge43: [
                 {
                "homeTitle": "Elton",
                "homeElevation": [
                    "style a 2850 sq ft. |",
                    "style b 2843 sq ft. |",
                    "style c 2850 sq ft.",
                ],
                "homePhoto": "/img/houses/elton.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Elton.pdf"
            },
            {
                "homeTitle": "Labelle",
                "homeElevation": [
                    "style a 3016 sq ft. | ",
                    "style b 3011 sq ft. | ",
                    "style c 3011 sq ft.",
                ],
                "homePhoto": "/img/houses/labelle.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Labelle.pdf"
            },
            {
                "homeTitle": "Osbourne",
                "homeElevation": [
                    "style a 3089 sq ft. | ",
                    "style b 3081 sq ft. | ",
                    "style c 3096 sq ft.",
                ],
                "homePhoto": "/img/houses/osbourne.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Osbourne.pdf"
            }],
            aspenridge45: [
                            {
                "homeTitle": "Bowie",
                "homeElevation": [
                    "style a 3202 sq ft.",
                ],
                "homePhoto": "/img/houses/bowie.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Bowie.pdf"
            },
            {
                "homeTitle": "Franklin",
                "homeElevation": [
                    "style a 3228 sq ft. | ",
                    "style b 3220 sq ft. | ",
                    "style c 3242 sq ft.",
                ],
                "homePhoto": "/img/houses/franklin.jpg",
                "homeSitePlanPDF": "/files/aspenridge-siteplan/Franklin.pdf"
            }],
            form: {
                sourceQuery:""
            }  
        }
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation();
      this.getPageQuery();
    },
    methods: {
        getPageQuery() {
            this.form.sourceQuery = localStorage.getItem("sourceQuery");
        }
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }
</script>

<style>

</style>